import { computed, observable, runInAction } from 'mobx';
import { get } from '../utils';

class NoPaginationList {
    private route: string;
    private params: any;
    @observable public lists: any[] = [];

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    async fetch(callback?, errs?) {
        let obj = Object.assign(this.params);
        get(this.route, obj).then((d) => {
            let data = d.data;
            // if (!data) return false;
            if (d) {
                runInAction(() => {
                    this.lists = data || [];
                    callback && callback(data);
                });
            } else {
                callback && callback([]);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    @computed
    get list() {
        return this.lists.slice();
    }
}

export default NoPaginationList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/noPaginationList.ts